'use strict';

define(
    'BetSlipWindowCtrl',[
        'RunnerSaddleModel',
        'BetsSvc',
        'StatePersistenceFac',
        'PreferencesCookieFac',
        'RaceStatusUtils'
    ],
    function (RunnerSaddleModel,
              _BetsSvc,
              _StatePersistenceFac,
              _PreferencesCookieFac,
              RaceStatusUtils) {

        function BetSlipWindowCtrl($scope,
                                   $rootScope,
                                   BetsSvc,
                                   StatePersistenceFac,
                                   $window,
                                   $uibModal,
                                   PreferencesCookieFac,
                                   $filter,
                                   $routeParams,
                                   GTMFac,
                                   UserProfileSvc,
                                   RaceInfoFac,
                                   $interval,
                                   AmountOptionsFac,
                                   trackSvc,
                                   betSlipWindowAlertsFac,
                                   GraphRaceRunners,
                                   WagerProfileFac,
                                   $log,
                                   $timeout,
                                   LocalStorageFac,
                                   PreferencesFac) {

            var resubmit = false,
                previousState = StatePersistenceFac.loadState("bt"),
                userPrefs = PreferencesCookieFac.getPreferences(),
                prefBetAmount = userPrefs.bet_amount,
                confirmDialog = null,
                parameters = $routeParams,
                readParameters = false,
                prefBetType,
                verifiedBetTypeWhenFromRunnerClick = false,
                trackDataCtrl = [],
                initialSetup = true,
                closeBetSlipReceiptBtn = false,
                onFirstTimeOpen = true,
                betsCanceled = false,
                betsSubmitted = false,
                sizeToggle = 1,
                loadFirstTime,
                initialFetchRetry = 3,
                fetchRetry = initialFetchRetry,
                subscribeEvent,
                nFectaWagerTypes = ['E6', 'E7', 'E8', 'E9', 'E10', 'E11', 'E12', 'E13', 'E14'],
                pickWagerType = [310, 330, 340, 350, 360, 370, 380, 390, 400, 510, 520, 530, 540, 550, 560, 570, 580, 690, 700, 710, 720, 730, 740, 750, 760],
                trifectaWagerType = [160, 170, 180, 190, 200],
                exactaWagerType = [110, 120, 130, 140, 150, 770],
                superfectaWagerType = [210, 220, 230, 240, 250],
                superhighfiveWagerType = [260, 270, 280, 290, 300];

            // GraphQL variables
            var graphSubscription;
            var graphPollerInterval = $filter('CMSLabels')('low', 'graphqlPollingRates') || 30000; // in ms

            $scope.data = {};

            $rootScope.isGreyhoundRace = !!parameters.greyhounds || false;
            $scope.isLoading = true;
            $scope.data.blockAnyBetting = false;
            $scope.data.closedForBettingMessage = $filter('CMSValue')('betTicketClosedCurrentRace') + ($rootScope.isIE ? '. ' + $filter('CMSValue')('betTicketChooseAnotherRace') : '');
            $scope.data.incorrectBetSize = $filter('CMSValue')('betTicketIncorrectBetSize');
            $scope.data.incorrectAmountValueMessage = $filter('CMSValue')('betSlipAmountEnteredIsIncorrect');
            $scope.data.minimumBetAmountMessage = $filter('CMSValue')('BetSlipMinimumAmountIs');
            $scope.data.maximumBetAmountMessage = $filter('CMSValue')('BetSlipMaximumAmountIs');
            $scope.data.nearestAmountsMessage = $filter('CMSValue')('BetSlipNearestAmounts');
            $scope.data.forbiddenBettingStates = angular.fromJson($filter('CMSValue')('forbiddenBettingStates'));
            $scope.data.otherAmountStep = 0.5;

            $scope.events = {
                betTypeChanged: _betTypeChanged,
                betAmountChanged: _betAmountChanged,
                otherAmountChanged: _otherAmountChanged,
                submitBet: _submitBet,
                pushRaceInfo: _pushRaceInfo,
                changeTab: _changeTab,
                closeRaceInfo: _closeRaceInfo,
                closeInfoMessage: _closeInfoMessage,
                checkIfResumit: _checkIfResumit,
                toggleSelection: _toggleSelection,
                toggleAll: _toggleAll,
                isSelected: _isSelected,
                isSelectedAll: _isSelectedAll,
                isSelectable: _isSelectable,
                isActiveTab: _isActiveTab,
                legHasRunner: _legHasRunner,
                toggleTab: _toggleTab,
                closeMessage: _closeMessage,
                closeBetslip: _closeBetslip,
                goBack: _goBack,
                confirmBet: _confirmBet,
                createSameBet: _createSameBet,
                createSameRace: _createSameRace,
                repeatBet: _repeatBet,
                validateRepeatValue: _validateRepeatValue,
                closeAlert: betSlipWindowAlertsFac.closeAlert,
                closeAlertForever: _closeAlertForever,
                filterAmountOptions: true,
                areAllRunnersScratched: _areAllRunnersScratched,
                isNewWagerType: _isNewWagerType,
                isScratchedHorseInList: _isScratchedHorseInList
            };

            $scope.data.layoutType = null;
            $scope.data.activeTab = 0;
            $scope.data.activeNavTab = 0;
            $scope.data.totalSelected = [];
            $scope.data.cols = [];
            $scope.data.legRaces = [];
            $scope.data.legRacesRunners = [];
            $scope.data.isLeg = false;
            $scope.data.isBetConfirmed = true;
            $scope.data.betButtonLabel = '';
            $scope.data.legColumnHeight = [];
            $scope.data.mtp = {
                time: 0,
                status: 'time-format'
            };

            var show = {
                viewBET: "bet",
                viewCONFIRMATION: "confirmation",
                viewRECEIPT: "receipt",
                messageSUCCESS: "success",
                messageERROR: "error",
                messageWARN: "warn",
                messageHIDE: ""
            };

            $scope.data.showConfirmWarn = true;
            $scope.data.showMessage = show.messageHIDE;
            $scope.data.showView = show.viewBET;

            $scope.alerts = betSlipWindowAlertsFac.alerts;

            $scope.existsScratchedHorse = false;

            if (!angular.isUndefined(userPrefs.show_bet_confirm) && userPrefs.show_bet_confirm == 0) {
                $scope.data.isBetConfirmed = false;
            }

            $scope.data.betSlipWindowParams = [
                '/betslip',
                $routeParams.trackAbbr,
                $routeParams.perfAbbr,
                $routeParams.raceNumber
            ].join('/');

            function _updateCurrentRaceAndCurrentRaceIndex(trackData, races, raceNumber) {
                var raceNumberInt = parseInt(raceNumber, 10);

                $scope.data.currentRace = _.find(trackData, function (race) {
                    return parseInt(race.raceNumber, 10) === raceNumberInt;
                });

                if ($scope.data.currentRace) {
                    $scope.data.currentRace.perfAbbr = $scope.data.currentRace.track ? $scope.data.currentRace.track.perfAbbr : '';

                    $scope.data.currentRaceIndex = _.findIndex(races, function (race) {
                        return race.id === $scope.data.currentRace.id;
                    });

                    $rootScope.appTitle = 'TVG Bet Ticket | ' + $scope.data.currentRace.trackName + ' - R' + $scope.data.currentRace.raceNumber;
                }
            }

            function _roundAmount(amount) {
                return $filter('roundAmount')(amount);
            }

            function _createSameBet() {
                _validateBet();

                var p = gtmDefaultBetSlipData();
                p.eventLabel = 'BetTicketReceipt-SameBet';
                p.gaEventAction = 'Bet Ticket Receipt Page Click';
                p.gaEventLabel = 'Create Same Bet';
                GTMFac.GTMEvent().when($rootScope.userSession).send($rootScope, 'siteClick', p);

                _resetRepeat();
                _goBack();
                betsCanceled = false;
            }

            function _createSameRace() {
                var p = gtmDefaultBetSlipData();
                p.eventLabel = 'BetTicketReceipt-SameRace';
                p.gaEventAction = 'Bet Ticket Receipt Page Click';
                p.gaEventLabel = 'Bet Same Race';
                GTMFac.GTMEvent().when($rootScope.userSession).send($rootScope, 'siteClick', p);

                _resetRepeat();
                _clearSelection($scope.data.selectedBetType);
                _resetCurrentBetOptions($scope.data.selectedBetType, true);

                $scope.data.betEnabled = false;

                _goBack();
                betsCanceled = false;
            }

            function _checkInteger(value) {
                return (typeof value === 'number') && isFinite(value) && Math.floor(value) === value;
            }

            function _validateRepeatValue() {
                $scope.data.repeatValid = false;
                if (_checkInteger($scope.data.repeatTimes) && $scope.data.repeatTimes <= 25) {
                    betSlipWindowAlertsFac.closeAlertByIdentifier('invalidRepeatTime');
                    if ($rootScope.accountBalanceNumber && angular.isNumber($rootScope.accountBalanceNumber)) {
                        $scope.data.repeatValid = $rootScope.accountBalanceNumber >= parseFloat($scope.data.betValidation.betCost * $scope.data.repeatTimes);
                    } else {
                        $scope.data.repeatValid = true;
                    }
                } else if (_checkInteger($scope.data.repeatTimes) && $scope.data.repeatTimes > 25) {
                    $scope.data.repeatValid = false;
                    betSlipWindowAlertsFac.addAlert({
                        id: 'invalidRepeatTime',
                        type: 'warning',
                        closeable: false,
                        message: 'Bets can be repeated a maximum of x25'
                    });
                }
            }

            function _repeatBet() {
                _validateBet();

                var p = gtmDefaultBetSlipData();
                p.gaEventLabel = 'Repeat bet';
                p.eventLabel = 'BetTicketReceipt-RepeatBet';
                p.gaEventAction = 'Bet Ticket Receipt Page Click';
                GTMFac.GTMEvent().when($rootScope.userSession).send($rootScope, 'siteClick', p);

                $scope.data.showView = show.viewCONFIRMATION;
                $scope.data.showConfirmWarn = false;
                $scope.data.repeatTimes = 1;
                $scope.data.maxRepeatTimes = 9999;
                $scope.data.repeatBet = true;
                $scope.data.repeatValid = true;
            }

            function _closeBetslip() {
                closeBetSlipReceiptBtn = true;

                $window.close();
            }

            function _goBack() {
                if ($scope.data.showView === show.viewCONFIRMATION) {
                    var p = gtmDefaultBetSlipData();

                    p.gaEventCategory = 'Bet';
                    p.gaEventAction = 'Bet Cancelled';
                    p.gaEventLabel = _talentPickHostValid() ? "Talent Pick Bet Cancelled | " + $window.opener.talentPickHost : 'Standard Bet Cancelled';
                    if (betsCanceled) {
                        p.customerStatus = 'Returning';
                    } else {
                        p.customerStatus = 'First Time';
                        betsCanceled = true;
                    }

                    GTMFac.GTMEvent().when($rootScope.userSession).send($rootScope, 'betStandardCancelled', p);
                }

                $scope.data.showView = show.viewBET;
                $rootScope.restartBetslipSubscribe = true;
            }

            function _closeMessage() {
                $scope.data.showMessage = show.messageHIDE;
                return false;
            }

            function _setBettingInfo(fromRaceChange) {

                if (!$scope.data.currentRace) return false;

                $scope.data.formExpanded = previousState ? previousState.data.formExpanded : false;
                $scope.data.raceOpenForBetting = RaceStatusUtils.isRaceOpenForBetting($scope.data.currentRace);
                $scope.data.raceOpenForLiveVideo = RaceStatusUtils.isRaceOpenForLiveVideo($scope.data.currentRace);

                if (!$scope.data.raceOpenForBetting) {
                    $scope.data.currentRace.closedForBetting = true;
                }

                $scope.data.runners = $scope.data.currentRace.bettingInterests;

                $scope.data.wagerTypes = $scope.data.currentRace.wagerTypes;
                _updateMtp($scope.data.currentRace.postTime);

                if (!$scope.data.raceOpenForBetting) {
                    betSlipWindowAlertsFac.addAlert({
                        id: 'closed',
                        type: 'error',
                        closeable: true,
                        message: 'This race is now closed for betting. Please select a new race.'
                    });
                } else {
                    betSlipWindowAlertsFac.closeAlertByIdentifier('closed');
                }

                if (initialSetup) {
                    var wagerType = $scope.data.wagerTypes[0];
                    $scope.data.colsChecked = [];
                    $scope.data.currentBetSelections = [[]];
                    $scope.data.otherAmountShown = false;

                    if (!$rootScope.activeFeatures.useUamPreferencesBetslip) {
                        userPrefs = PreferencesCookieFac.getPreferences();
                    }

                    _readBetslipParameters();

                    // any changes by user will override default values (prefBetAmount too)
                    if (wagerType || fromRaceChange) {
                        _restoreBetOptions(wagerType);
                    }

                    if ($scope.data.selectedBetType) {
                        wagerType = $scope.data.selectedBetType;
                    }

                    // check if prefBetAmount exists and if it is a valid bet amount for current wager type
                    if (prefBetAmount && ($rootScope.userSession || readParameters)) {
                        if (wagerType && angular.isArray(wagerType.betAmounts)) {
                            if (userPrefs && userPrefs.bet_prefs && userPrefs.bet_prefs.useCustomBetAmount && wagerType.id === Number(userPrefs.bet_prefs.defaultBetType)) {
                                var size = wagerType.betAmounts.length;

                                $scope.data.betAmount = prefBetAmount;

                                for (var i = 0; i < size; ++i) {
                                    if (wagerType.betAmounts[i].amount == prefBetAmount) {
                                        $scope.data.betAmount = wagerType.betAmounts[i].amount;
                                        $scope.data.selectedBetAmount = wagerType.betAmounts[i];
                                        break;
                                    }
                                }

                                if (wagerType.id !== Number(userPrefs.bet_prefs.defaultBetType)) {
                                    $scope.data.betAmount = wagerType.betAmounts[i].amount;
                                    $scope.data.selectedBetAmount = wagerType.betAmounts[i];
                                }
                            } else if (userPrefs && userPrefs.bet_prefs && userPrefs.bet_prefs.useCustomBetAmount && wagerType.id !== Number(userPrefs.bet_prefs.defaultBetType) && userPrefs.bet_prefs.default_bet_amount[wagerType.id]) {
                                var amount = wagerType.betAmounts.find(
                                    function (betAmount) {
                                        return betAmount.amount == userPrefs.bet_prefs.default_bet_amount[wagerType.id];
                                    });
                                if (!amount) {
                                    $scope.data.betAmount = userPrefs.bet_prefs.default_bet_amount[wagerType.id];
                                    $scope.data.selectedBetAmount = wagerType.betAmounts[wagerType.betAmounts.length - 1];
                                    $scope.data.otherAmountShown = true;
                                } else {
                                    $scope.data.betAmount = amount.amount;
                                    $scope.data.selectedBetAmount = amount;
                                }
                            } else {
                                $scope.data.betAmount = wagerType.betAmounts[0].amount;
                                $scope.data.selectedBetAmount = wagerType.betAmounts[0];
                            }
                            $scope.data.selectedBetAmounts = wagerType.betAmounts;

                        }

                        // This is to guarantee that we have a value that matches one of these wager amounts.
                        // For some races, e.g. Hong-Kong, the preferred bet amount is not one of the values presented in
                        // the wager amounts list.
                        if (!$scope.data.betAmount || !$scope.data.selectedBetAmount) {
                            var betAmountObj = AmountOptionsFac.getClosestOrEqualAmountObject({amount: prefBetAmount},
                                (wagerType || {}).betAmounts, 'amount');
                            if(betAmountObj && typeof betAmountObj === 'object'){
                                $scope.data.betAmount = betAmountObj.amount;
                                $scope.data.selectedBetAmount = betAmountObj;
                                $scope.data.otherAmount = parseFloat(betAmountObj.amount);
                            }
                        }
                    }

                    if (parameters && parameters.betamount) {
                        var parameterBetAmount = parseFloat(parameters.betamount);
                        var betAmount = wagerType.betAmounts.find(
                            function (betAmount) {
                                return betAmount.amount === parameterBetAmount;
                            });
                        $scope.data.betAmount = parameterBetAmount;
                        $scope.data.selectedBetAmount = betAmount || $scope.data.selectedBetAmounts[$scope.data.selectedBetAmounts.length - 1];
                        $scope.data.otherAmount = parameterBetAmount;
                        $scope.data.otherAmountShown = !betAmount;

                    }

                    readParameters = false;
                    $scope.data.previousSelectedBeType = $scope.data.selectedBetType;
                    initialSetup = false;
                    _validateBet();
                }
            }

            function _getPrefBetType(id) {
                for (var i = 0; i < $scope.data.wagerTypes.length; ++i) {
                    if ($scope.data.wagerTypes[i].id == id) {
                        return $scope.data.wagerTypes[i];
                    }
                }
                return null;
            }

            function _restoreBetOptions(wagerType) {
                var currentBetType = null;

                if (previousState
                    && previousState.data.currentRace
                    && previousState.data.currentRace.id == $scope.data.currentRace.id) {
                    currentBetType = previousState.data.selectedBetType;
                } else {
                    if (prefBetType && ($rootScope.userSession || readParameters)) {
                        currentBetType = prefBetType;
                    } else {
                        currentBetType = wagerType;
                    }
                }

                var validBetOption = _betTypeInCurrentBets(currentBetType);
                if (validBetOption) {
                    $scope.data.selectedBetType = validBetOption;
                    _resetCurrentBetOptions(validBetOption);
                } else {
                    _resetCurrentBetOptions(wagerType);
                }
            }

            function _betTypeInCurrentBets(currentBetType) {
                var isInCurrentBets = null;

                for (var i = 0; i < $scope.data.wagerTypes.length; i++) {
                    if (angular.equals($scope.data.wagerTypes[i], currentBetType)) {
                        isInCurrentBets = $scope.data.wagerTypes[i];
                        break;
                    }
                }

                return isInCurrentBets;
            }

            function _restoreState() {
                if (previousState
                    && previousState.data.currentRace
                    && previousState.data.currentRace.id == $scope.data.currentRace.id) {

                    $scope.data.currentSelectedCol = previousState.data.currentSelectedCol;
                    $scope.data.colsChecked = previousState.data.colsChecked;
                    $scope.data.currentBetSelections = previousState.data.currentBetSelections;

                    if (previousState.data.selectedBetAmounts) {
                        $scope.data.selectedBetAmounts = previousState.data.selectedBetAmounts;
                    }
                    if (previousState.data.selectedBetAmount) {
                        $scope.data.selectedBetAmount = previousState.data.selectedBetAmount;
                    }
                    if (previousState.data.betAmount) {
                        $scope.data.betAmount = previousState.data.betAmount;
                    }
                    if (previousState.data.otherAmount) {
                        $scope.data.otherAmount = previousState.data.otherAmount;
                    }
                    if (previousState.data.minBetAmount) {
                        $scope.data.minBetAmount = previousState.data.minBetAmount;
                    }

                    $scope.data.otherAmountShown = previousState.data.otherAmountShown;
                }
                previousState = null;
                StatePersistenceFac.resetState("bt");
            }

            function _setRunnersSaddles() {

                var runnersSaddlesByLeg = [];

                if (_.isUndefined($scope.data) || _.isUndefined($scope.data.currentBetSelections)) {
                    return;
                }

                $scope.data.currentBetSelections.forEach(function (leg, index) {
                    var selectedRunners = leg; //array of numbers
                    //convert selectedRunners array of numbers of array of strings
                    selectedRunners = selectedRunners.map(function (selectedRunner) {
                        return selectedRunner.toString();
                    });

                    var runners = $scope.data.isLeg ? $scope.data.legRacesRunners[index] : $scope.data.runners;

                    //intersect selectedRunners with list of runners
                    var auxSelectedRunnersSaddle = runners.filter(function (runner) {
                        var selectedRunnerId = runner.horseID.replace(/[^\d.]/g, '');
                        return selectedRunners.indexOf(runner.horseID) !== -1 ||
                            selectedRunners.indexOf(selectedRunnerId) !== -1;
                    });

                    //map runners to runnerSaddles
                    auxSelectedRunnersSaddle = auxSelectedRunnersSaddle.map(function (runner) {
                        return new RunnerSaddleModel(
                            runner.saddleColor,
                            runner.numberColor,
                            runner.horseID,
                            runner.horseName,
                            runner.bettingInterestNumber
                        );
                    });
                    runnersSaddlesByLeg.push(auxSelectedRunnersSaddle);
                });

                $scope.data.selectedSaddle = runnersSaddlesByLeg;
            }

            function _getTempBetAmount() {
                var tempBetAmount = $scope.data.betValidation && $scope.data.betValidation.betCost ? $scope.data.betValidation.betCost : $scope.data.betAmount;

                return _roundAmount(tempBetAmount);
            }

            function _sendGTMBetSuccess(placedBetData) {
                var p = gtmDefaultBetSlipData();
                p.gaEventCategory = 'Bet';
                p.gaEventAction = 'Bet Success';
                p.gaEventLabel = (placedBetData && placedBetData.serialNumber) ? placedBetData.serialNumber : undefined;
                p.betAmount = _getTempBetAmount();
                p.customerStatus = 'First Time';
                p.runnerAmount = $scope.data.betAmount;
                GTMFac.GTMEvent().send($rootScope, 'bet', p);
            }

            function _sendGTMBetRepeat() {
                var p = gtmDefaultBetSlipData();
                p.gaEventLabel = 'Repeat bet | ' + $scope.data.repeatTimes;
                p.eventLabel = 'BetTicket-RepeatBet';
                GTMFac.GTMEvent().when($rootScope.userSession).send($rootScope, 'siteClick', p);
            }

            function _sendGTMBetError(errorCode) {
                var trackName = $scope.data.currentRace && $scope.data.currentRace.trackName ? $scope.data.currentRace.trackName : '';
                var amount = $scope.data.selectedBetAmount && $scope.data.selectedBetAmount.amount ? _roundAmount($scope.data.selectedBetAmount.amount) : '';
                var raceNumber = $scope.data.currentRace && $scope.data.currentRace.raceNumber ? $scope.data.currentRace.raceNumber : '';
                var betType = $scope.data.selectedBetType && $scope.data.selectedBetType.name ? $scope.data.selectedBetType.name : '';
                var sectionName = 'Bet Ticket | Bet Ticket Page';
                if ($scope.data.showView === show.viewCONFIRMATION) {
                    sectionName = 'Bet Ticket | Bet Ticket Confirmation Page';
                } else if ($scope.data.showView === show.viewRECEIPT) {
                    sectionName = 'Bet Ticket | Bet Ticket Receipt Page';
                }

                var event = {
                    event: "bet",
                    gaEventCategory: "Bet",
                    gaEventAction: "Bet Error",
                    gaEventLabel: errorCode,
                    module: sectionName,
                    tag: $scope.data.currentBetSelections.join(", "),
                    trackName: trackName,
                    raceNumber: raceNumber,
                    betId: undefined,
                    betAmount: amount,
                    betType: betType,
                    sport: $rootScope.isGreyhoundRace ? "Greyhounds Racing" : "Horse Racing",
                    repeatBet: $scope.data.repeatBet,
                    runnerAmount: $scope.data.betAmount
                };

                GTMFac.GTMEvent().send($rootScope, 'betStandardError', event);
            }

            function _createApptentiveConversation(user) {
                if (typeof window !== "undefined" && window.ApptentiveSDK) {
                    window.ApptentiveSDK.createConversation({
                        app_release: {
                            version: "1.0.0"
                        },
                        person: {
                            custom_data: {
                                account_id: user.accountNumber,
                                first_name: user.firstName,
                                last_name: user.lastName,
                                email: user.emailAddress,
                                day_of_birthday: "",
                                home_city: user.homeAddress
                                ? user.homeAddress.City : "",
                                gender: "",
                                country: "",
                                phone: "",
                                full_home_address: "",
                                key_account_yn: false,
                                value_band: ""
                            }
                        },
                        device: {
                            custom_data: {
                                flash: true,
                                es6: false
                            }
                        }
                    });
                }

            }

            function _placeBet() {
                $scope.isPlacingBet = true;

                var repeatBet = (($rootScope.activeFeatures.betSlipRepeatBet ? $rootScope.activeFeatures.betSlipRepeatBet : false) && $scope.data.repeatBet);

                $scope.data.betValidation.repeat = 1;

                if (repeatBet) {
                    $scope.data.betValidation.repeat = $scope.data.repeatTimes;
                    $scope.data.repeatValid = true;
                    _sendGTMBetRepeat();
                }

                //TODO need to pass my selection instead of using betValidation.wagers
                BetsSvc.placeBet($scope.data.betValidation, $scope.data.currentRace).then(
                    function (placedBetData) {
                        _sendGTMBetSuccess(placedBetData);

                        $scope.data.showMessage = show.messageSUCCESS;
                        $scope.data.showView = show.viewRECEIPT;

                        $rootScope.$emit('bet_placed', $scope.data.currentRace);

                        $scope.isPlacingBet = false;
                        betsSubmitted = false;

                        // Apptentive event
                        _createApptentiveConversation($rootScope.user);
                        if (typeof window !== "undefined" && window.ApptentiveSDK) {
                            window.ApptentiveSDK.engage("Places bet");
                        }
                    },
                    function (betError) {
                        $scope.data.errorMessage = betError.errorMessageKey;
                        _sendGTMBetError(betError.errorCode);

                        if (betError.multiBet) {
                            $scope.isPlacingBet = false;
                            $scope.isPlacingBet = false;
                            _showErrorMessage('multipleBetError', betError.message, 'warning');
                            $rootScope.$emit('bet_placed', $scope.data.currentRace);
                            betsSubmitted = false;
                            _sendGTMBetSuccess();
                            return;
                        }

                        // if error inSufficient balance allow user to go back
                        if (betError.errorCode === "136518") {
                            _disableBet();
                            $scope.isPlacingBet = false;
                            $scope.data.infoMessage = betError.message;
                            $scope.data.infoTitle = 'Insuficient Funds';
                            _showErrorMessage('insuficientFunds', betError.message);
                            return;
                        }

                        $scope.data.showMessage = show.messageERROR;
                        $scope.data.showView = show.viewRECEIPT;

                        $scope.isPlacingBet = false;
                        betsSubmitted = false;
                    }
                );
            }

            function _talentPickHostValid() {
                return $window.opener && $window.opener.talentPickHost && $window.opener.talentPickHost !== "";
            }

            function _confirmBet() {
                $scope.data.isBetConfirmed = !$scope.data.isBetConfirmed;
                userPrefs.show_bet_confirm = $scope.data.isBetConfirmed ? 1 : 0;

                UserProfileSvc.setRequestBetConfirmationPreference($scope.data.isBetConfirmed)
                    .then(function () {
                            var p = gtmDefaultBetSlipData();
                            p.gaEventLabel = $scope.data.isBetConfirmed ? 'Uncheck No Confirmation Window' : 'No Confirmation Window';
                            p.eventLabel = 'BetTicket-Confirmation';
                            GTMFac.GTMEvent().when($rootScope.userSession).send($rootScope, 'siteClick', p);
                        },
                        function () {
                            //error
                        });
            }

            function _submitBet() {
                if($scope.data.blockAnyBetting){
                    return null;
                }
                _validateBet();

                if (($scope.data.showView === show.viewBET && !$scope.data.isBetConfirmed) || $scope.data.showView === show.viewCONFIRMATION) {
                    var p = gtmDefaultBetSlipData();

                    p.gaEventCategory = 'Bet';
                    p.gaEventAction = 'Bet Submit';
                    p.gaEventLabel = _talentPickHostValid() ? "Talent Pick Bet Submitted | " + $window.opener.talentPickHost : 'Standard Bet Submitted';
                    p.betAmount = _getTempBetAmount();
                    if (betsSubmitted) {
                        p.customerStatus = 'Returning';
                    } else {
                        p.customerStatus = 'First Time';
                        betsSubmitted = true;
                    }

                    GTMFac.GTMEvent().when($rootScope.userSession).send($rootScope, "betStandardSubmit", p);
                }

                if (!$rootScope.userSession) {
                    //Message placeholder, until is returned from cms
                    $scope.data.infoMessage = 'Please login in order to bet';
                    $scope.data.infoTitle = 'Login Required';

                    _disableBet();
                    betSlipWindowAlertsFac.addAlert(
                        {
                            id: 'noSession',
                            type: 'error',
                            closeable: true,
                            message: $scope.data.infoMessage
                        }
                    );

                } else {
                    _finaliseBet();
                }
            }

            /*
             * param id: String
             * param message: String
             * param type: String error | warning
             * Show error message and disable bet
             */
            function _showErrorMessage(id, message, type) {
                type = typeof type !== 'undefined' ? type : 'error';
                betSlipWindowAlertsFac.addAlert({
                    id: id,
                    type: type,
                    message: message,
                    closeable: false
                });
            }


            /*
             * after all checks place bet and send gtm event
             */
            function _finaliseBet() {
                _setRunnersSaddles();

                if ($scope.data.showView === show.viewBET && $scope.data.isBetConfirmed) {
                    var gtmEvent = gtmDefaultBetSlipData();
                    gtmEvent.gaEventCategory = 'Bet';
                    gtmEvent.gaEventAction = 'Bet Start';
                    gtmEvent.gaEventLabel = _talentPickHostValid() ? "Talent Pick Bet Start | " + $window.opener.talentPickHost : 'Standard Bet Start';
                    gtmEvent.customerStatus = betsCanceled ? 'Returning' : 'First Time';
                    GTMFac.GTMEvent().when($rootScope.userSession).send($rootScope, 'betStandardStart', gtmEvent);

                    $scope.data.showView = show.viewCONFIRMATION;
                } else {
                    _placeBet();
                }
            }

            function _disableBet() {
                $scope.data.betEnabled = false;
            }

            function _enableBet() {
                $scope.data.betEnabled = true;
            }

            function _betTypeChanged(wager) {
                betSlipWindowAlertsFac.clearAlertsExcept("bettingForbidden");
                _resetCurrentBetOptions(wager);
                _adjustSizeFixRender();
            }

            function _clearSelection(wager) {
                var i = null;
                $scope.data.currentSelectedCol = null;
                $scope.data.colsChecked = [];

                if (parameters.fromRunnerClick === "true"
                    && angular.isArray($scope.data.currentBetSelections)
                    && verifiedBetTypeWhenFromRunnerClick == false
                    && $scope.data.currentBetSelections.length < wager.columnCount && !readParameters) {

                    for (i = 0; i < wager.columnCount; i++) {
                        $scope.data.currentBetSelections[i] = [];
                    }
                    verifiedBetTypeWhenFromRunnerClick = true;
                } else if (!readParameters || !angular.isArray($scope.data.currentBetSelections)) {
                    $scope.data.currentBetSelections = [];

                    for (i = 0; i < wager.columnCount; i++) {
                        $scope.data.currentBetSelections.push([]);
                    }
                } else if (angular.isArray($scope.data.currentBetSelections) && $scope.data.currentBetSelections.length < wager.columnCount) {
                    for (i = 0; i < wager.columnCount; i++) {
                        if (!$scope.data.currentBetSelections[i]) {
                            $scope.data.currentBetSelections[i] = [];
                        }
                    }
                }
            }

            function _resetCurrentBetOptions(wager, usePreviousChosenBetAmount) {
                var previousWager = $scope.data.previousSelectedBeType;
                var previousBetAmount = $scope.data.betAmount;

                if (wager) {
                    if (previousWager && previousWager.id > 71) {
                        _clearSelection(wager);
                    } else if (wager.id > 71) {
                        _clearSelection(wager);
                    } else if (!previousWager) {
                        _clearSelection(wager);
                    }

                    $scope.data.previousSelectedBeType = $scope.data.selectedBetType;

                    $scope.data.selectedBetAmounts = wager.betAmounts;

                    $scope.data.minBetAmount = wager.minBetAmount;

                    $scope.data.runners = $scope.data.currentRace.bettingInterests;

                    $scope.data.otherAmountShown = false;

                    if (angular.isArray(wager.betAmounts) && wager.betAmounts.length && !usePreviousChosenBetAmount) {
                        if (userPrefs && userPrefs.bet_prefs) {
                            var defaultBetAmount = Number(userPrefs.bet_prefs.default_bet_amount[wager.id]);
                            if (pickWagerType.includes(wager.id)) {
                                defaultBetAmount = Number(userPrefs.bet_prefs.default_bet_amount.P);
                            } else if (trifectaWagerType.includes(wager.id)) {
                                defaultBetAmount = Number(userPrefs.bet_prefs.default_bet_amount["160"]);
                            } else if (exactaWagerType.includes(wager.id)) {
                                defaultBetAmount = Number(userPrefs.bet_prefs.default_bet_amount["110"]);
                            } else if (superfectaWagerType.includes(wager.id)) {
                                defaultBetAmount = Number(userPrefs.bet_prefs.default_bet_amount["210"]);
                            } else if (superhighfiveWagerType.includes(wager.id)) {
                                defaultBetAmount = Number(userPrefs.bet_prefs.default_bet_amount["260"]);
                            }

                            // If a customer’s betting preference is higher than the maximum allowed wager amount,
                            // the bet ticket should default to the maximum allowed wager amount
                            if(defaultBetAmount > wager.maxBetAmount){
                                defaultBetAmount = wager.maxBetAmount;
                                prefBetAmount = wager.maxBetAmount;
                            }

                            if (userPrefs.bet_prefs.useCustomBetAmount && defaultBetAmount) {
                                var amount = wager.betAmounts.find(
                                    function (betAmount) {
                                        return betAmount.amount === defaultBetAmount;
                                    });
                                $scope.data.betAmount = defaultBetAmount;
                                $scope.data.selectedBetAmount = amount;
                                $scope.data.otherAmount = defaultBetAmount;
                                $scope.data.otherAmountShown = !amount;

                                if (!amount) {
                                    $scope.data.selectedBetAmount = $scope.data.selectedBetAmounts[$scope.data.selectedBetAmounts.length - 1];
                                }
                            } else {
                                $scope.data.betAmount = wager.betAmounts[0].amount;
                                $scope.data.selectedBetAmount = wager.betAmounts[0];
                                $scope.data.otherAmount = wager.betAmounts[0].amount;
                            }
                        } else if (!$scope.data.betAmount && !$scope.data.selectedBetAmount) {
                            // Reaching here means that the preferred bet amount wasn't found in the list of bet
                            // amounts of the first wager type (see "_setBettingInfo" code after "if(initialSetup)")
                            // This is to guarantee that we have a value that matches one of these wager amounts.
                            // For some races, e.g. Hong-Kong, the preferred bet amount is not one of the values presented in
                            // the wager amounts list.
                            var betAmountObj = AmountOptionsFac.getClosestOrEqualAmountObject({amount: prefBetAmount},
                                wager.betAmounts, 'amount');
                            $scope.data.betAmount = betAmountObj.amount;
                            $scope.data.selectedBetAmount = betAmountObj;
                            $scope.data.otherAmount = parseFloat(betAmountObj.amount);
                        } else {
                            var wagerHasAmount = wagerContainsBetAmount($scope.data.betAmount || 0);
                            var selectedAmountIsDefault = wagerContainsDefaultAmout(wager.betAmounts, $scope.data.betAmount || 0);

                            if (!wagerHasAmount || (!!wagerHasAmount && !selectedAmountIsDefault)) {
                                $scope.data.betAmount = wager.betAmounts[0].amount;
                                $scope.data.selectedBetAmount = wager.betAmounts[0];
                            }
                        }
                    } else {
                        var amountt = wager.betAmounts.find(
                            function (betAmount) {
                                return betAmount.amount === previousBetAmount;
                            });
                        $scope.data.betAmount = previousBetAmount;
                        $scope.data.selectedBetAmount = amountt;
                        $scope.data.otherAmount = previousBetAmount;
                        $scope.data.otherAmountShown = !amountt;

                        if (!amountt) {
                            $scope.data.selectedBetAmount = $scope.data.selectedBetAmounts[$scope.data.selectedBetAmounts.length - 1];
                        }
                    }

                    _restoreState();
                    _validateBet();
                }
            }

            function wagerContainsBetAmount(amount) {
                if (amount < 1 && $scope.data.minBetAmount < 1 && _isMultipleOfMinBetAmount(amount)) {
                    return true;
                }

                if (amount >= $scope.data.minBetAmount && amount >= 1) {
                    return true;
                }

                $scope.data.selectedBetAmount = $scope.data.selectedBetAmounts[0];
                $scope.data.betAmount = $scope.data.selectedBetAmount.amount;
                $scope.data.otherAmount = parseFloat($scope.data.selectedBetAmount.amount);
                $scope.data.otherAmountShown = false;

                return false;
            }

            function wagerContainsDefaultAmout(betAmounts, amount) {
                return !!_.find(betAmounts, function (betAmount) {
                    return betAmount.amount && betAmount.amount === amount;
                });
            }

            function _filterAmountOptions() {
                return AmountOptionsFac.removeOtherAmountOptionForHKRaces($scope.data.currentRace);
            }

            function _betAmountChanged() {
                betSlipWindowAlertsFac.closeAlertByIdentifier('incorrectBetSize');
                $scope.data.otherAmount = $scope.data.selectedBetAmount.amount ? parseFloat($scope.data.selectedBetAmount.amount) : null;

                var p = gtmDefaultBetSlipData();
                p.eventLabel = $scope.data.otherAmount === null ? 'BetTicket-OtherAmount' : 'BetTicket-DefaultAmount';
                p.gaEventLabel = $scope.data.otherAmount === null ? 'Select Other Amount' : 'Select Default Amount';
                GTMFac.GTMEvent().send($rootScope, 'siteClick', p);

                if (!$scope.data.otherAmount) {
                    $scope.data.betAmount = 0;
                    $scope.data.otherAmountShown = true;
                } else {
                    $scope.data.betAmount = $scope.data.otherAmount;
                    $scope.data.otherAmountShown = false;
                }
                _validateBet();
            }

            function _isMultipleOfMinBetAmount(value) {
                var intPart = parseInt(value, 10),
                    decPart = parseInt((value - Math.floor(value)) * 100, 10),
                    minimumAmount = $scope.data.minBetAmount,
                    minDecPart = parseInt((minimumAmount - Math.floor(minimumAmount)) * 100, 10),
                    isMultiple = minDecPart == 0 ? true : decPart % minDecPart == 0,
                    remainder = null,
                    correctValue;

                if (!isMultiple) {
                    remainder = (decPart % minDecPart);
                    if (remainder <= (minDecPart / 2) && decPart - remainder > 0) {
                        decPart = decPart - remainder;
                    } else {
                        decPart = decPart + minDecPart - remainder;
                    }
                }

                correctValue = intPart + (decPart / 100);

                return correctValue === value;
            }

            function _otherAmountChanged(value, valid, isBlur) {

                if (isBlur) {
                    betSlipWindowAlertsFac.closeAlertByIdentifier('incorrectBetSize');
                    _enableBet();
                }

                $scope.data.otherAmountStep = value < 1 && $scope.data.minBetAmount < 1 && value > 0 ? $scope.data.minBetAmount : 1;

                $scope.data.betAmount = 0;

                if (!value && !valid) {
                    if (isBlur) {
                        _showInfoMessage($scope.data.incorrectAmountValueMessage);
                    }
                } else if (value < $scope.data.minBetAmount) {
                    if (isBlur) {
                        _showInfoMessage($scope.data.minimumBetAmountMessage + ' ' + $filter('currency')($scope.data.minBetAmount, "$"));
                    }
                } else {
                    if (value > 0 && value < 1 && $scope.data.minBetAmount < 1 && !_isMultipleOfMinBetAmount(value)) {
                        if (isBlur) {
                            _showInfoMessage($scope.data.nearestAmountsMessage + ' ' + _getsNearestDecimalValues(value)[0] + ' and ' + _getsNearestDecimalValues(value)[1]);
                        }
                    } else if (value > 1 && (value % 1 != 0)) {
                        if (isBlur) {
                            _showInfoMessage($scope.data.nearestAmountsMessage + ' ' + Math.floor(value) + ' and ' + (Math.floor(value) + 1));
                        }
                    } else {
                        $scope.data.betAmount = value;
                    }
                }

                _validateBet();
            }

            function _getsNearestDecimalValues(value) {
                var decPart = parseInt((value - Math.floor(value)) * 100, 10);
                var minDecPart = parseInt(($scope.data.minBetAmount - Math.floor($scope.data.minBetAmount)) * 100, 10);
                var remainder = (decPart % minDecPart);
                return [(Math.floor((decPart - remainder) / 10) / 10).toFixed(1), ((Math.floor((decPart - remainder) / 10) / 10) + $scope.data.minBetAmount).toFixed(1)];
            }

            function _countRunners() {
                var runners = $scope.data.legRacesRunners.length === 0 ? $scope.data.runners : $scope.data.legRacesRunners[$scope.data.activeTab],
                    array = [];

                runners = runners.filter(function (runner) {
                    var invalid = false;

                    if (array.indexOf(runner.bettingInterestNumber) >= 0 || runner.currentOdds.Numerator == "Scr") {
                        invalid = true;
                    }

                    array.push(runner.bettingInterestNumber);

                    if (invalid) {
                        return null;
                    }
                    return runner;
                });

                return runners.length;
            }

            function _validateBet() {
                $scope.data.betValidation = BetsSvc.calculateBetTotal(
                    $scope.data.betAmount,
                    $scope.data.selectedBetType,
                    $scope.data.currentBetSelections
                );

                $scope.data.betEnabled = false;
                if ($scope.data.betValidation.betCost > 0) {
                    if ($scope.data.selectedBetType.isKey || (!$scope.data.betValidation.errorResultsStr)) {
                        $scope.data.betEnabled = true;
                        betSlipWindowAlertsFac.closeAlertByIdentifier('insuficientFunds');
                    }
                }
            }

            function _checkIfResumit() {
                if (resubmit) {
                    resubmit = false;
                    $scope.events.submitBet();
                }
            }

            function _pushRaceInfo() {
                $rootScope.raceInfoModal = $uibModal.open({
                    backdropClass: 'tvgmodal-backdrop',
                    windowTemplateUrl: 'js/modules/Utilities/templates/modal-window.html',
                    windowClass: 'race-info',
                    template: '<div class="race-info-header">Race Info</div><button class="close-btn" ng-click="events.closeRaceInfo()"></button><raceinfo></raceinfo>',
                    scope: $scope
                });
            }

            function _changeTab(tabName) {
                $scope.raceInfoSelectedTab = tabName;
                var obj = {
                    RIT_H: 'Free Handicapping',
                    RIT_P: 'Probables',
                    RIT_C: 'Changes',
                    RIT_PLS: 'Pools',
                    RIT_W: 'Will Pays'
                };

                var p = {};
                p.screenName = 'Bet Ticket Page';
                p.sectionName = 'Races | ' + obj[tabName];

                if (typeof ga !== 'undefined') {
                    ga('send', 'pageview', {
                        title: p.sectionName
                    });
                }

                if (tabName && obj[tabName]) {
                    GTMFac.sendGTMEvent($scope, p.event, p);
                }
            }

            function _closeRaceInfo() {
                if ($rootScope.raceInfoModal) {
                    $rootScope.raceInfoModal.close();
                    $rootScope.raceInfoModal = null;
                }
            }

            function _showInfoMessage(message) {
                betSlipWindowAlertsFac.clearAlertsExcept("bettingForbidden");
                $scope.data.infoMessage = message;

                _disableBet();
                betSlipWindowAlertsFac.addAlert(
                    {
                        id: 'incorrectBetSize',
                        type: 'warning',
                        closeable: false,
                        message: $scope.data.infoMessage
                    }
                );
            }

            function _closeInfoMessage() {

                if (confirmDialog) {
                    confirmDialog.close();
                    confirmDialog = null;
                }
            }

            function _reloadUserPreferencesAfterLoggingIn() {
                //if it is a resubmit we should not be updating the controller with the user preferences
                if (!resubmit) {
                    previousState = null;
                    onFirstTimeOpen = true;
                    initialSetup = true;
                    if ($rootScope.activeFeatures.useUamPreferencesBetslip) {
                        PreferencesFac.getUserPreferences().then(function (preferences) {
                            userPrefs = preferences;
                        }).finally(_setBettingInfo);
                    } else {
                        userPrefs = PreferencesCookieFac.getPreferences();
                        _setBettingInfo();
                    }
                }
            }

            function _isScratchedHorseInList() {
                var runners = $scope.data.legRacesRunners.length === 0 ? $scope.data.runners : $scope.data.legRacesRunners[$scope.data.activeTab];

                if (!Array.isArray(runners)) {
                    return false;
                }
                return runners.some(function (runner) {
                    return runner.scratched;
                });
            }

            function _removeScratchedHorsesFromSelection() {
                var removedScratched = false;
                var runners = $scope.data.legRacesRunners.length === 0 ? _getRunnersArray($scope.data.runners, $scope.data.selectedBetType.columnCount) : $scope.data.legRacesRunners;
                if (!Array.isArray(runners)) {
                    return;
                }
                runners.forEach(function (runnerLeg, runnerLegKey) {

                    if (!Array.isArray(runnerLeg)) {
                        return;
                    }

                    var betSelections = $scope.data.currentBetSelections[runnerLegKey];

                    if (!Array.isArray(betSelections)) {
                        return;
                    }

                    betSelections.forEach(function (betSelection, betSelectionKey) {
                        var validRunner = _.filter(runnerLeg, function (runner) {
                            if (betSelection === runner.bettingInterestNumber && _areAllRunnersScratched(runner)) {
                                //if there is a scratchet horse in the bet selection, recalculate bet cost
                                removedScratched = true;
                            }
                            return (betSelection === runner.bettingInterestNumber && !_areAllRunnersScratched(runner));
                        });
                        if (validRunner.length === 0) {
                            $scope.data.currentBetSelections[runnerLegKey].splice(betSelectionKey, 1);
                        }
                    });
                });

                if (removedScratched) {
                    //if there is a scratchet horse in the bet selection, recalculate bet cost
                    _validateBet();
                }
            }

            function _getRunnersArray(runners, times) {
                var runnersArray = [];
                for (var i = 0; i < times; i++) {
                    runnersArray.push(runners);
                }
                return runnersArray;
            }

            function _toggleSelection(betInterest, dsIndex) {
                if ($scope.data.currentRace.closedForBetting) {
                    return;
                }
                var colOfSelections = $scope.data.currentBetSelections[dsIndex],
                    selectionIndex = colOfSelections.indexOf(betInterest);

                if ($scope.data.selectedBetType.isKey) {
                    if (dsIndex == 0) {
                        if (selectionIndex < 0 && !$scope.data.colsChecked[1]) {
                            colOfSelections = [betInterest];

                            var secondColOfSelections = $scope.data.currentBetSelections[1],
                                selectionIndexOnSecondCol = secondColOfSelections.indexOf(betInterest);

                            if (selectionIndexOnSecondCol >= 0) {
                                secondColOfSelections[selectionIndexOnSecondCol] = null;
                                secondColOfSelections = secondColOfSelections.filter(function (item) {
                                    return item !== null;
                                });
                                $scope.data.currentBetSelections[1] = secondColOfSelections;
                                $scope.data.colsChecked[1] = false;
                            }
                        } else if (selectionIndex < 0 && $scope.data.colsChecked[1]) {
                            colOfSelections = [betInterest];
                            $scope.data.currentBetSelections[dsIndex] = [betInterest];
                            _toggleAll(false, 1);
                        } else {
                            colOfSelections = [];
                            $scope.data.colsChecked[dsIndex] = false;
                        }
                    } else if (dsIndex == 1) {
                        if (selectionIndex < 0) {
                            colOfSelections.push(betInterest);
                            var firstColOfSelections = $scope.data.currentBetSelections[0],
                                selectionIndexOnFirstCol = firstColOfSelections.indexOf(betInterest);

                            if (selectionIndexOnFirstCol >= 0) {
                                firstColOfSelections[selectionIndexOnFirstCol] = null;
                                firstColOfSelections = firstColOfSelections.filter(function (item) {
                                    return item !== null;
                                });
                                $scope.data.currentBetSelections[0] = firstColOfSelections;
                            }
                        } else {
                            colOfSelections[selectionIndex] = null;
                            $scope.data.colsChecked[dsIndex] = false;
                        }
                    }
                } else {
                    if (selectionIndex < 0) {
                        colOfSelections.push(betInterest);
                    } else {
                        colOfSelections[selectionIndex] = null;
                        $scope.data.colsChecked[dsIndex] = false;
                    }
                }

                colOfSelections = colOfSelections.filter(function (item) {
                    return item !== null;
                });

                $rootScope.$emit('runnerSelectionsChanged',
                    $scope.data.currentRace,
                    $scope.data.selectedBetType.columnCount,
                    dsIndex,
                    colOfSelections
                );

                $scope.data.currentBetSelections[dsIndex] = colOfSelections;

                if ($scope.data.selectedBetType.isKey) {
                    var i = (dsIndex > 0 ? dsIndex : dsIndex + 1);
                    $scope.data.colsChecked[i] = _countRunners() == ($scope.data.currentBetSelections[0].length + $scope.data.currentBetSelections[i].length);
                } else {
                    $scope.data.colsChecked[dsIndex] = _countRunners() == $scope.data.currentBetSelections[dsIndex].length;
                }

                _validateBet();
            }

            function _toggleAll(checked, dsIndex) {
                if ($scope.data.currentRace.closedForBetting) {
                    return;
                }

                var runners = $scope.data.isLeg ? $scope.data.legRacesRunners[dsIndex] : $scope.data.runners;

                var colOfSelections = $scope.data.currentBetSelections[dsIndex],
                    keyBI = null,
                    alreadyUsed = {};

                checked = typeof checked == 'undefined' ? false : checked;

                if (!checked) {
                    $scope.data.colsChecked[dsIndex] = true;

                    if ($scope.data.selectedBetType.isKey) {
                        keyBI = $scope.data.currentBetSelections[0][0];
                    }

                    // select all runners that are not scratched and not a key
                    // bet, without repeating ids
                    colOfSelections = runners.filter(function (runner) {
                        var isScratched = _areAllRunnersScratched(runner);
                        var isKeyBI = (runner.bettingInterestNumber === keyBI);
                        var isUnique = !alreadyUsed[runner.bettingInterestNumber];
                        var isValid = isUnique && !isScratched && !isKeyBI;

                        if (isValid) {
                            alreadyUsed[runner.bettingInterestNumber] = true;
                        }

                        return isValid;
                    }).map(function (runner) {
                        return runner.bettingInterestNumber;
                    });
                } else {
                    $scope.data.colsChecked[dsIndex] = false;
                    colOfSelections = [];
                }
                $scope.data.currentBetSelections[dsIndex] = colOfSelections;

                _validateBet();

                var p = gtmDefaultBetSlipData();
                p.gaEventLabel = !checked ? 'Select All Horses' : 'UnSelect All Horses';
                p.eventLabel = !checked ? 'BetTicket-SelectAll' : 'BetTicket-UnSelectAll';
                GTMFac.GTMEvent().send($rootScope, 'siteClick', p);
            }

            function _toggleTab(tab) {
                $scope.data.activeTab = tab - 1;
            }

            function _isSelected(betInterest, dsIndex) {
                return angular.isArray($scope.data.currentBetSelections) && $scope.data.currentBetSelections.length > 0 ? $scope.data.currentBetSelections[dsIndex].indexOf(betInterest) >= 0 : false;
            }

            function _isSelectedAll(dsIndex) {
                return $scope.data.colsChecked[dsIndex];
            }

            function _isActiveTab(tab) {
                return tab - 1 == $scope.data.activeTab;
            }

            function _isSelectable(betInterest, dsIndex) {
                if ($scope.data.selectedBetType.isKey && !_isSelected(betInterest, dsIndex)) {
                    var col = (dsIndex == 0 ? 1 : 0);
                    return !_isSelected(betInterest, col);
                }
                return true;
            }

            function _legHasRunner(row, col) {
                return angular.isDefined($scope.data.legRacesRunners[col][row]);
            }

            function betSlipCloseEvent() {
                var p = gtmDefaultBetSlipData();

                if (closeBetSlipReceiptBtn) {
                    p.customerStatus = 'First Time';
                    p.gaEventLabel = 'Close Bet Ticket';
                    p.eventLabel = 'BetTicketReceipt-Close';
                    p.gaEventAction = 'Bet Ticket Receipt Page Click';

                    GTMFac.GTMEvent().when($rootScope.userSession).send($rootScope, 'siteClick', p);

                } else {
                    p.customerStatus = 'First Time';
                    p.gaEventLabel = 'Close Bet Ticket';
                    p.eventLabel = 'BetTicket-Close';
                    p.gaEventAction = 'Bet Ticket Page Click';

                    GTMFac.GTMEvent().when($rootScope.userSession).send($rootScope, 'siteClick', p);
                }
            }

            function gtmDefaultBetSlipData() {
                var trackAbbr = $scope.data.currentRace && $scope.data.currentRace.trackAbbr ? $scope.data.currentRace.trackAbbr : '';
                var amount = $scope.data.selectedBetAmount && $scope.data.selectedBetAmount.amount ? _roundAmount($scope.data.selectedBetAmount.amount) : '';
                var raceNumber = $scope.data.currentRace && $scope.data.currentRace.raceNumber ? $scope.data.currentRace.raceNumber : '';
                var betType = $scope.data.selectedBetType && $scope.data.selectedBetType.abbreviation ? $scope.data.selectedBetType.abbreviation : '';
                var sectionName = 'Bet Ticket | Bet Ticket Page';
                if ($scope.data.showView === show.viewCONFIRMATION) {
                    sectionName = 'Bet Ticket | Bet Ticket Confirmation Page';
                } else if ($scope.data.showView === show.viewRECEIPT) {
                    sectionName = 'Bet Ticket | Bet Ticket Receipt Page';
                }

                var runnerList = $rootScope.user && $rootScope.user.wagerString ? $rootScope.user.wagerString : '';

                return GTMFac.EventBuilder()
                    .withScreenName('Bet Ticket Page')
                    .withSectionName(sectionName)
                    .withBetName(betType + ' | ' + trackAbbr + ' | R' + raceNumber + ' | ' + amount + ' | ' + runnerList)
                    .withBetAmount(amount)
                    .withBetType(betType)
                    .withGaEventCategory('Site Click')
                    .withGaEventAction('Bet Ticket Page Click')
                    .withRaceNumber(raceNumber)
                    .withTrackName($scope.data.currentRace && $scope.data.currentRace.trackName ? $scope.data.currentRace.trackName : '')
                    .withRunnerSelectionList(runnerList)
                    .build();
            }

            function _initBetSlipPoller() {
                _getGraphData();
            }

            function _processTrackData(trackData) {
                trackDataCtrl = trackData;
                $scope.data.races = trackData;
                if (!trackData.length) {
                    $scope.data.currentRace = null;
                    $scope.isLoading = false;
                } else {
                    _updateCurrentRaceAndCurrentRaceIndex(trackData, $scope.data.races, $routeParams.raceNumber);

                    if ($scope.data.currentRace) {
                        _setBettingInfo();
                        _setBetSlipLoaded();
                    }
                }
            }

            function _adjustSizeFixRender() {
                //SE-513 - Do not remove this piece of code (seems useless but solves the reported bug)
                $window.resizeBy( sizeToggle,0);
                sizeToggle *= -1;
            }

            function _setBetSlipLoaded() {
                $scope.isLoading = false;
                _adjustSizeFixRender();
            }

            function _onDataRefresh(graphData) {

                // update all future races because this race can have a pick 2/3/4/5/6 bet option
                // and its legs need to be updated
                $scope.data.races.forEach(function (race) {
                    graphData.races.forEach(function (graphRace) {
                        var raceNumber = parseInt(graphRace.raceNumber, 10);

                        if (parseInt(race.raceNumber, 10) === raceNumber) {
                            RaceInfoFac.setLowestOdd(graphRace.bettingInterests);
                            var isFavoriteBIScratched = RaceInfoFac.isFavoriteBIScratched(graphRace.bettingInterests);

                            race.bettingInterests.forEach(function (raceRunner) {
                                graphRace.bettingInterests.forEach(function (graphRaceRunner) {
                                    if (raceRunner.bettingInterestNumber === graphRaceRunner.biNumber) {
                                        graphRaceRunner.runners.forEach(function (graphRaceRunnerHorse) {
                                            if (raceRunner.horseID === graphRaceRunnerHorse.runnerId) {
                                                raceRunner.scratched = graphRaceRunnerHorse.scratched;
                                            }
                                        });

                                        var bi = _treatBettingInterestRunnersOdds(graphRaceRunner, isFavoriteBIScratched);
                                        var biRunner = bi.runners[0];


                                        raceRunner.currentOdds.denominator = biRunner.currentOdds ?  biRunner.currentOdds.denominator: 0;
                                        raceRunner.currentOdds.numerator = biRunner.currentOdds? biRunner.currentOdds.numerator: 99;
                                        raceRunner.currentOddsString = biRunner.currentOddsString;
                                        raceRunner.favorite = biRunner.favorite;


                                        for (var i = 1; i < bi.runners.length; i++) {
                                            var runner = bi.runners[i];

                                            if (!runner.scratched) {
                                                // only update odds string if other runners are not scratched
                                                // else, the odds string will be determined by the first runner
                                                if(runner.currentOdds){
                                                    raceRunner.currentOddsString = runner.currentOddsString;
                                                    raceRunner.currentOdds.numerator = runner.currentOdds.numerator;
                                                    raceRunner.favorite = runner.favorite;
                                                }
                                            }
                                        }
                                    }
                                });
                            });

                            //Update the current race data
                            if (graphRace.trackAbbr == $scope.data.currentRace.trackAbbr && raceNumber === parseInt($scope.data.currentRace.raceNumber, 10)) {
                                $scope.data.currentRace = race;
                                $scope.data.currentRace.status = graphRace.status.code;
                                $scope.data.currentRace.perfAbbr = graphRace.track.perfAbbr;
                                $scope.data.currentRace.trackName = graphRace.track.name;

                                $scope.data.raceOpenForBetting = RaceStatusUtils.isRaceOpenForBetting($scope.data.currentRace);
                                $scope.data.raceOpenForLiveVideo = RaceStatusUtils.isRaceOpenForLiveVideo($scope.data.currentRace);

                                if (!$scope.data.raceOpenForBetting) {
                                    $scope.data.currentRace.closedForBetting = true;
                                } else {
                                    $scope.data.currentRace.closedForBetting = false;
                                }
                            }
                        }
                    });
                });

                _removeScratchedHorsesFromSelection();
                _setBettingInfo();
            }

            function _onDataRefreshError(response) {
                $log.error('Error getting data for this race via graph: ', response);
            }

            function _subscribeGraphData() {
                var queryParams = {
                    trackAbbr: $routeParams.trackAbbr,
                    wagerProfile: WagerProfileFac.getWagerProfile()
                };

                if (subscribeEvent) {
                    $timeout.cancel(subscribeEvent);
                }

                subscribeEvent = $timeout(function () {
                    graphSubscription = GraphRaceRunners.subscribe(
                        queryParams,
                        {success: _onDataRefresh, fail: _onDataRefreshError},
                        graphPollerInterval,
                        true
                    );
                }, graphPollerInterval);
            }

            function _treatBettingInterestRunnersOdds(bettingInterest, isFavoriteBIScratched) {
                bettingInterest.runners.forEach(function (runner) {
                    runner.currentOdds = {};
                    runner.currentOdds.denominator = bettingInterest.currentOdds? bettingInterest.currentOdds.denominator: 0;
                    runner.currentOdds.numerator = bettingInterest.currentOdds? bettingInterest.currentOdds.numerator: 99;
                    if(bettingInterest.currentOdds){
                        runner.currentOddsString = bettingInterest.currentOdds.numerator != null ?
                            bettingInterest.currentOdds.numerator + (bettingInterest.currentOdds.denominator ? '/' + bettingInterest.currentOdds.denominator : '') : 'N/A';
                        runner.favorite = isFavoriteBIScratched ? RaceInfoFac.isFavoriteOdd(bettingInterest) : bettingInterest.favorite;
                    }else{
                        runner.currentOddsString = "99";
                        runner.favorite = false;
                    }


                    if (_areAllRunnersScratched(runner)) {
                        runner.currentOddsString = 'Src';
                        runner.currentOdds.numerator = 'Src';
                    }
                });

                return bettingInterest;
            }

            function _getGraphData() {
                var options = {
                    trackAbbr: $routeParams.trackAbbr,
                    wagerProfile: WagerProfileFac.getWagerProfile()
                };

                if (graphSubscription && GraphRaceRunners.isSubscribed()) {
                    GraphRaceRunners.unsubscribe(graphSubscription);
                }

                GraphRaceRunners.get(options).then(function (response) {
                    var graphData = angular.copy(response);

                    graphData.races.forEach(function (graphRace) {
                        graphRace.id = graphRace.trackAbbr + '_' + graphRace.track.perfAbbr + '_' + graphRace.raceNumber;
                        graphRace.status = graphRace.status.code;
                        graphRace.trackName = graphRace.track.name;
                        graphRace.postTime = new Date(graphRace.postTime);

                        var runnersArray = [];
                        var isFavoriteBIScratched = RaceInfoFac.isFavoriteBIScratched(graphRace.bettingInterests);

                        RaceInfoFac.setLowestOdd(graphRace.bettingInterests);
                        graphRace.bettingInterests.forEach(function (bettingInterest) {
                            var mainRunner = bettingInterest.runners[0];
                            mainRunner.saddleColor = bettingInterest.saddleColor;
                            mainRunner.numberColor = bettingInterest.numberColor;
                            mainRunner.horseID = mainRunner.runnerId;
                            mainRunner.bettingInterestNumber = bettingInterest.biNumber;

                            if (bettingInterest.runners.length > 1) {
                                // means this betting interest has coupled runners (ie. 1 / 1A)
                                mainRunner.coupledRunners = [];

                                for (var i = 1; i < bettingInterest.runners.length; i++) {
                                    var coupledRunner = bettingInterest.runners[i];
                                    mainRunner.coupledRunners.push(coupledRunner);
                                }
                            }

                            bettingInterest.runners[0] = mainRunner;
                            var bi = _treatBettingInterestRunnersOdds(bettingInterest, isFavoriteBIScratched);

                            mainRunner = bi.runners[0];
                            runnersArray.push(mainRunner);
                        });

                        graphRace.bettingInterests = runnersArray;
                        var wagerTypesArray = [];
                        graphRace.wagerTypes.forEach(function (wagerType) {
                            var wagerTypeObj = {};

                            var betAmounts = [];
                            wagerType.wagerAmounts.forEach(function (wagerAmount) {
                                var betAmount = {
                                    amountString: $filter('currency')(wagerAmount, "$"),
                                    amount: wagerAmount
                                };
                                betAmounts.push(betAmount);
                            });
                            betAmounts.push({
                                amountString: 'other',
                                amount: null
                            });
                            wagerTypeObj.id = wagerType.type.id;
                            wagerTypeObj.betAmounts = betAmounts;
                            wagerTypeObj.maxBetAmount = wagerType.maxWagerAmount;
                            wagerTypeObj.minBetAmount = wagerType.minWagerAmount;
                            wagerTypeObj.name = wagerType.type.name;
                            wagerTypeObj.abbreviation = wagerType.type.code;
                            wagerTypeObj.columnCount = wagerType.columnCount;
                            wagerTypeObj.columnType = wagerType.columnType;
                            wagerTypeObj.isBox = wagerType.isBox;
                            wagerTypeObj.isKey = wagerType.isKey;
                            wagerTypeObj.legCount = wagerType.legCount;
                            wagerTypeObj.maxBIsPerLeg = wagerType.maxBIsPerLeg;
                            wagerTypeObj.minBIsPerLeg = wagerType.minBIsPerLeg;
                            wagerTypeObj.poolsPerBI = wagerType.poolsPerBI;
                            wagerTypeObj.positionCount = wagerType.positionCount;
                            wagerTypeObj.isWheel = wagerType.isWheel;

                            wagerTypesArray.push(wagerTypeObj);
                        });
                        graphRace.wagerTypes = wagerTypesArray;
                    });

                    $scope.data.races = graphData.races;
                    fetchRetry = initialFetchRetry;

                    _processTrackData(graphData.races);
                    _subscribeGraphData();
                }).catch(function (err) {
                    // Retry request on error
                    if (fetchRetry > 0) {
                        $timeout(function () {
                            _getGraphData();
                            fetchRetry--;
                        }, (6000 / fetchRetry));
                    } else {
                        $scope.isLoading = false;
                        $scope.data.currentRace = null;
                        $log.error(err.message);
                    }
                });
            }


            $scope.$watch('data.selectedBetType', function (currWager) {
                if (currWager && angular.isDefined(currWager)) {
                    $scope.data.betEnabled = false;
                    $scope.data.activeTab = 0;
                    $scope.data.layoutType = currWager.columnCount > 1 ? 'multiple' : 'single';
                    $scope.data.cols = _.range(1, currWager.columnCount + 1);
                    $scope.data.legColumnHeight = [];

                    /*<!-- Grand Slam message -->*/
                    if ($scope.data.selectedBetType.abbreviation == 'GS' && !$scope.hasSeenGrandSlamInfo && $rootScope.activeFeatures.showGrandSlamInfo) {
                        betSlipWindowAlertsFac.addAlert({
                            id: 'grandslam',
                            type: 'warning',
                            closeable: true,
                            message: $filter('CMSValue')('grandSlamInfoMessage'),
                            closeForever: true
                        });
                    }

                    if (nFectaWagerTypes.indexOf($scope.data.selectedBetType.abbreviation) > -1 && !$scope.hasSeenNfectaInfo) {
                        betSlipWindowAlertsFac.addAlert({
                            id: 'nfecta',
                            type: 'warning',
                            closeable: true,
                            message: $filter('CMSValue')('nfectaInfoMessage'),
                            closeForever: true
                        });
                    }

                    if (currWager.legCount > 1) {
                        $scope.data.legRaces = $scope.data.races.slice($scope.data.currentRaceIndex, $scope.data.currentRaceIndex + currWager.columnCount);
                        $scope.data.legRacesRunners = [];
                        $scope.data.isLeg = true;
                        var legHeight = 0,
                            colRunners = [],
                            legRace;

                        for (var i = 0; i < currWager.columnCount; i++) {
                            colRunners = [];
                            legRace = i < $scope.data.legRaces.length ? $scope.data.legRaces[i] : null;
                            colRunners = legRace ? legRace.bettingInterests : [];
                            $scope.data.legRacesRunners.push(colRunners);

                            legHeight = colRunners.length > legHeight ? colRunners.length : legHeight;
                        }

                        $scope.data.legColumnHeight = _.range(1, legHeight + 1);
                    } else {
                        $scope.data.legRaces = [];
                        $scope.data.legRacesRunners = [];
                        $scope.data.isLeg = false;
                    }

                    _removeScratchedHorsesFromSelection();
                    _validateBet();
                }
            });

            function _closeAlertForever(index) {
                if ($scope.data.selectedBetType.abbreviation == 'GS') {
                    LocalStorageFac.setItem("hasSeenGrandSlamInfo", true);
                    $scope.hasSeenGrandSlamInfo = true;
                    betSlipWindowAlertsFac.closeAlert(index);
                }

                if (nFectaWagerTypes.indexOf($scope.data.selectedBetType.abbreviation) > -1) {
                    LocalStorageFac.setItem('hasSeenNfectaInfo', true);
                    $scope.hasSeenNfectaInfo = true;
                    betSlipWindowAlertsFac.closeAlert(index);
                }
            }

            function _readBetslipParameters() {
                if (parameters && parameters.betselections && onFirstTimeOpen) {
                    $scope.data.currentBetSelections = _parseBetSelectionsString(parameters.betselections);
                }

                if (parameters && parameters.betamount && !isNaN(parameters.betamount) && onFirstTimeOpen) {
                    prefBetAmount = _roundAmount(parameters.betamount);
                } else if (userPrefs && userPrefs.bet_prefs && parameters && parameters.bettype) {
                    prefBetAmount = _roundAmount(userPrefs.bet_prefs.default_bet_amount[parameters.bettype]);
                } else if (userPrefs && userPrefs.bet_prefs && !parameters.bettype) {
                    prefBetAmount = _roundAmount(userPrefs.bet_prefs.default_bet_amount[userPrefs.bet_prefs.defaultBetType]);
                } else {
                    prefBetAmount = _roundAmount($scope.data.wagerTypes[0].betAmounts[0].amount);
                }

                $scope.data.otherAmount = prefBetAmount;

                if (parameters && parameters.bettype && !isNaN(parameters.bettype) && onFirstTimeOpen) {
                    prefBetType = _getPrefBetType(parameters.bettype);
                } else if (userPrefs && userPrefs.bet_prefs) {
                    prefBetType = _getPrefBetType(userPrefs.bet_prefs.defaultBetType);
                } else {
                    prefBetType = _getPrefBetType(userPrefs.bet_type);
                }

                if (onFirstTimeOpen) {
                    onFirstTimeOpen = false;
                }

                if (!angular.isUndefined(userPrefs.show_bet_confirm)) {
                    $scope.data.isBetConfirmed = !!userPrefs.show_bet_confirm;
                }

                readParameters = true;
            }

            function _resetRepeat() {
                $scope.data.repeatBet = false;
                $scope.data.repeatTimes = 1;
                $scope.data.maxRepeatTimes = 9999;
                $scope.data.repeatValid = true;
            }

            function _updateMtp(postTime) {
                $scope.data.mtp.status = 'time-format';
                $scope.data.mtp.time = $filter('raceMtp')(postTime);
                var mtp = (typeof $scope.data.mtp.time === 'string') ? $scope.data.mtp.time.split(' ') : [];
                if (mtp[1] === 'MTP') {
                    var time = parseInt(mtp[0]);
                    if (time <= 5) {
                        $scope.data.mtp.status = 'near';
                    } else if (time <= 15) {
                        $scope.data.mtp.status = 'med';
                    } else {
                        $scope.data.mtp.status = 'far';
                    }
                }
            }

            function _areAllRunnersScratched(bi) {
                if (!bi) {
                    return false;
                }

                if (bi.coupledRunners) {
                    var coupledRunnersScratched = _.filter(bi.coupledRunners, function (cr) {
                        return cr.scratched === true;
                    });

                    // to be true, the main BI runner has to be scratched, as well as all the bi coupled runners
                    return coupledRunnersScratched.length === bi.coupledRunners.length && bi.scratched;
                } else {
                    return !!bi.scratched;
                }
            }

            function _isNewWagerType(abbr) {
                return !!(abbr === 'GS' || nFectaWagerTypes.indexOf(abbr) > -1);
            }

            /**
             * Transform each selection leg String into an array of integers of selections.
             *
             * @param {String} betSelectionsString The bet selections string.
             * Expected to have the following regexp format: ([\d]\,*\;*)
             * @returns {*} the received parameter if not a valid String or an array of array(s) of integer(s).
             * @private
             */
            function _parseBetSelectionsString(betSelectionsString) {
                if (!betSelectionsString || typeof betSelectionsString !== 'string') {
                    return betSelectionsString;
                }

                return betSelectionsString.split(';')
                    .map(function (currentSelectionLeg) {
                        return _.reduce(currentSelectionLeg.split(','), function (result, currentSplitSelection) {
                            // parse String to integer
                            currentSplitSelection = parseInt(currentSplitSelection, 10);
                            if (!isNaN(currentSplitSelection) && !_.includes(result, currentSplitSelection)) {
                                result.push(parseInt(currentSplitSelection, 10));
                            }
                            return result;
                        }, [])
                            // Using Boolean as a function to convert a non-boolean value to a boolean value.
                            // This removes any selection that could not be parsed.
                            .filter(Boolean);
                    });
            }

            function _blockBettingBecauseOfState() {
                if (
                    $rootScope.activeFeatures.bettingBlockedByUserState &&
                    !$scope.data.blockAnyBetting &&
                    $rootScope.user &&
                    $rootScope.user.homeAddress != undefined &&
                    typeof $rootScope.user.homeAddress.State === "string"
                ) {
                    $scope.data.blockAnyBetting =
                        _.findIndex(
                            _.get(
                                $scope.data,
                                "forbiddenBettingStates.blockedStates",
                                ["AZ"]
                            ),
                            function (state) {
                                return (
                                    state.toLowerCase() ===
                                    $rootScope.user.homeAddress.State.toLowerCase()
                                );
                            }
                        ) !== -1;
                }

                if (
                    $rootScope.activeFeatures.bettingBlockedByUserState &&
                    !$scope.isLoading &&
                    $scope.data.blockAnyBetting
                ) {
                    betSlipWindowAlertsFac.addAlert({
                        id: "bettingForbidden",
                        type: "error",
                        closeable: false,
                        message: _.get(
                            $scope.data,
                            "forbiddenBettingStates.errorMessage",
                            "For legal reasons, we cannot accept wagers from your state on a computer. Try again on a mobile device using the app or mobile website"
                        ),
                    });
                }
            }

            (function init() {
                $scope.$watch("isLoading", _blockBettingBecauseOfState);
                $rootScope.$watch("user", _blockBettingBecauseOfState);

                $scope.$on('$destroy', function () {
                    var stateToSave = previousState || {
                        data: $scope.data
                    };

                    StatePersistenceFac.saveState('bt', stateToSave);

                    if (graphSubscription && GraphRaceRunners.isSubscribed()) {
                        GraphRaceRunners.unsubscribe(graphSubscription);
                    }
                });

                $scope.$on('login', _reloadUserPreferencesAfterLoggingIn);
                $scope.$on('session', _reloadUserPreferencesAfterLoggingIn);

                $scope.$on('sessionInvalid', function () {
                    $scope.sessionInvalid = true;
                });

                $scope.$on('BetSlip::RaceChanged', function (event, trackChanged) {
                    $scope.isLoading = true;
                    initialSetup = true;
                    if (trackChanged) {
                        betSlipWindowAlertsFac.clearAlertsExcept("bettingForbidden");
                        _initBetSlipPoller(initialSetup);
                    } else {
                        _updateCurrentRaceAndCurrentRaceIndex(trackDataCtrl, $scope.data.races, $routeParams.raceNumber);
                        $scope.isLoading = false;
                        betSlipWindowAlertsFac.clearAlertsExcept("bettingForbidden");
                        _adjustSizeFixRender();
                        _setBettingInfo(true);
                    }
                });

                $scope.$on('accountBalance_update', function () {
                    $scope.data.betEnabled = true; //Enable bet button when user deposits funds. Even if the funds after deposit are not enough, click on the button will proceed to bet validation.
                    betSlipWindowAlertsFac.closeAlertByIdentifier('insuficientFunds'); //Remove only the alert of insufficient funds
                });

                _getGraphData();

                $interval(function () {
                    _updateMtp($scope.data.currentRace.postTime);
                }, 15000);

                loadFirstTime = true;
                $rootScope.hideDepositOptions = true;
                $scope.hasSeenGrandSlamInfo = LocalStorageFac.getItem("hasSeenGrandSlamInfo");
                $scope.hasSeenNfectaInfo = LocalStorageFac.getItem("hasSeenNfectaInfo");
                _resetRepeat();
                window.addEventListener('unload', function () {
                    betSlipCloseEvent();
                });
            }());
        }

        BetSlipWindowCtrl.$inject = [
            '$scope',
            '$rootScope',
            'BetsSvc',
            'StatePersistenceFac',
            '$window',
            '$uibModal',
            'PreferencesCookieFac',
            '$filter',
            '$routeParams',
            'GTMFac',
            'UserProfileSvc',
            'RaceInfoFac',
            '$interval',
            'AmountOptionsFac',
            'trackSvc',
            'betSlipWindowAlertsFac',
            'GraphRaceRunners',
            'WagerProfileFac',
            '$log',
            '$timeout',
            'LocalStorageFac',
            'PreferencesFac'
        ];
        return BetSlipWindowCtrl;
    }
);

